import { combineReducers } from "redux";
import commonReducer from "../../store/reducers/commonReducer";
import pageReducer from "./pageReducer";
import UserReducer from "./user/userReducer";
import serverSideReducer from "./serverSideReducer";
import CmsHome from "../../store/reducers/cms";
import PermissionReducer from "../../store/reducers/cms/permissionReducer";
import WebinarReducer from "../../store/reducers/cms/webinarReducer";
import NewsletterReducer from "../../store/reducers/cms/newsletterReducer";
import ProductsReducer from "../../store/reducers/cms/productsReducer";
import ArticleReducer from "../../store/reducers/premium/mainsite/articleReducer";
import HomePageReducer from "../../store/reducers/premium/mainsite/homePageReducer";
import WebinarDetailReducer from "../../store/reducers/premium/mainsite/webinarReducer";
import ContentReducer from "../../store/reducers/premium/mainsite/contentReducer";
import ProductReducer from "../../store/reducers/premium/product/productReducer";
import PaymentReducer from "../../store/reducers/premium/payment/paymentReducer";
import LandingReducer from "../../store/reducers/premium/mainsite/landingReducer";
import articleWebinarMppingReducer from "../../store/reducers/cms/articleWebinarMappingReducer";
import coachingReducer from "../../store/reducers/cms/coachingReducer";
import countryReducer from "../../store/slices/country"
import registerReducer from "../../store/slices/register";
import blockUsersReducer from "../slices/blockUsers";
import domainReducer from "../../store/slices/domain.js"
import contactUserReducer from "../../store/slices/contactPushUser";
import hiringReducer from "../../store/slices/hiring";
import staffRegisterReducer from "../slices/staffRegister";
import videoReducer from "../../store/slices/video"
import staticPagesReducer from "../slices/staticPages"
import feedbackReducer from "../../store/slices/cp_feedback.js";
import studyabroadRankingPannelReducer from "../../store/slices/manageRankingPanel";
import authorReducer from "../../store/slices/authorProfile"
import articleAppReducer from "../../store/slices/articleApp.js"
import manageRP_Reducer from "../../store/slices/manageRP.js";
import predictorToolsReducer from '../../store/slices/managePredictorTools.js'
import faqReducer from "../../store/slices/faqs.js"
import urlCreationReducer from "../../store/slices/urlCreation.js";
import webStoryReducer from "../../store/slices/webStory.js";
import pollCreationReducer from "../slices/pollSlice.js";
import DialerReducer from "../../store/slices/pushDialer.js";
import degreeGroupingReducer from "../../store/slices/degreeOrdering.js";
import commentModerationReducer from "../../store/slices/commentMorderation.js";
import domainMappingReducer from "../../store/slices/domainMapping.js";
import deleteUserSliceReducer from "../slices/deleteUser.js";

export default combineReducers({
  userData: UserReducer,
  sharedDetails: commonReducer,
  pageDetails: pageReducer,
  serverSideData: serverSideReducer,
  cmsHome: CmsHome,
  cmsPermission: PermissionReducer,
  cmsWebinar: WebinarReducer,
  cmsNewsletter: NewsletterReducer,
  cmsProducts: ProductsReducer,
  articleDetails: ArticleReducer,
  homePageData: HomePageReducer,
  webinarDetails: WebinarDetailReducer,
  contentReducer: ContentReducer,
  productDetails: ProductReducer,
  paymentDetails: PaymentReducer,
  landingPageDetails: LandingReducer,
  spgMappingDetails: articleWebinarMppingReducer,
  cmsCoaching: coachingReducer,
  cmsCountry: countryReducer,
  registersReducer: registerReducer,
  blockUsersReducer: blockUsersReducer,
  staffRegisterReducer: staffRegisterReducer,
  cmsDomain: domainReducer,
  contactUser: contactUserReducer,
  hiringReducer: hiringReducer,
  videoReducer: videoReducer,
  staticPagesReducer: staticPagesReducer,
  rankingPannelReducer: studyabroadRankingPannelReducer,
  cmsFeedback: feedbackReducer,
  authorReducer: authorReducer,
  articleAppReducer:articleAppReducer,
  manageRP_Reducer:manageRP_Reducer,
  predictorToolsReducer:predictorToolsReducer,
  faqReducer:faqReducer,
  urlCreation:urlCreationReducer,
  webStoryReducer:webStoryReducer,
  pollCreationReducer:pollCreationReducer,
  DialerReducer:DialerReducer,
  degreeGroupingReducer:degreeGroupingReducer,
  commentModerationReducer:commentModerationReducer,
  domainMappingReducer:domainMappingReducer,
  deleteUserSliceReducer:deleteUserSliceReducer,
});
